/**
 * Application configuration and constants
 */

export const APP_CONFIG = {
  name: 'Logical Fallacy Analyzer',
  version: '1.0.0',
  description: 'AI-powered logical fallacy detection and argument analysis',
  author: 'Logical Fallacy Analyzer Contributors',
  repository: 'https://github.com/cipp-ashe/fallacy-flipper',
  homepage: 'https://fallacy-flipper.ashe.blog/',
  maxTextLength: 10000,
} as const;

export { EXPANDED_FALLACY_TYPES as FALLACY_TYPES } from './fallacyDefinitions';
export { UI_TEXT, UI_CONFIG as UI_DISPLAY_CONFIG, SEVERITY_OPTIONS } from './ui';

export const STORAGE_KEYS = {
  userPreferences: 'lfa_user_preferences',
  analysisHistory: 'lfa_analysis_history',
} as const;
